/** Message names the client sends to the server. */
export const CLIENT_MESSAGE = {
    input: "input",
    ability: "ability",
    chat: "chat",
};
//# sourceMappingURL=client.js.map